/* ==========================================================================
   Saints Reserve Wholesale — portal behaviour
   Loaded ONLY by layout/theme.wholesale.liquid.

   What this does today:
   - Order sheet kept in localStorage. Live mode (customer.b2b?) sends it to /cart then /checkout;
     other modes never call /cart.
   - Size-matrix inputs → order-sheet lines.
   - Bestseller strips fetched through the Section Rendering API (read-only GET).
   - Reorder from order history tables.
   - Small UI: drawer, gallery, page filter, sort, toasts.
   What it deliberately does NOT do: touch /cart, customers, or any admin data.
   ========================================================================== */
(function () {
  'use strict';
  var cfg = (window.SRW && window.SRW.config) || {};
  var STORE_KEY = 'srw_order_sheet_v1';
  var multiplier = Number(cfg.multiplier || 55);

  /* ---------- money ---------- */
  function money(cents) {
    var fmt = cfg.moneyFormat || '${{amount}}';
    var n = (Number(cents) || 0) / 100;
    function withSep(v, dec, thou, dp) {
      var parts = v.toFixed(dp).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou);
      return dp ? parts.join(dec) : parts[0];
    }
    return fmt
      .replace(/\{\{\s*amount\s*\}\}/, withSep(n, '.', ',', 2))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, withSep(n, '.', ',', 0))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, withSep(n, ',', '.', 2))
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, withSep(n, ',', '.', 0))
      .replace(/\{\{\s*amount_with_space_separator\s*\}\}/, withSep(n, ',', ' ', 2))
      .replace(/\{\{\s*amount_with_apostrophe_separator\s*\}\}/, withSep(n, '.', "'", 2));
  }
  function wsPrice(msrp) { return Math.round((Number(msrp) || 0) * multiplier / 100); }
  /* Live mode only: replace the Shopify cart with the order sheet, then hand off to checkout.
     Prices are NOT sent — Shopify prices each line from the customer's catalog. */
  var submitting = false;
  function submitSheet(btn) {
    if (cfg.mode !== 'live' || submitting) return;
    var items = sheet.lines.filter(function (l) { return l.qty > 0; }).map(function (l) { return { id: Number(l.id), quantity: Number(l.qty) }; });
    if (!items.length) return;
    submitting = true; btn.disabled = true; btn.textContent = 'Sending to checkout…';
    var root = cfg.rootUrl || '/';
    var note = function (msg) {
      var box = document.querySelector('[data-w-sheet-error]');
      if (!box) { box = document.createElement('div'); box.className = 'w-notice w-notice--bad'; box.setAttribute('role', 'alert'); box.setAttribute('data-w-sheet-error', ''); btn.parentNode.insertBefore(box, btn); }
      box.textContent = msg; box.hidden = !msg;
    };
    var reset = function (msg) { submitting = false; btn.disabled = false; btn.textContent = 'Review & submit order'; if (msg) { note(msg); toast(msg); } };
    var post = function (path, body) {
      return fetch(root + path, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify(body || {}) })
        .then(function (r) {
          /* Shopify's bot check answers with an HTML page, not JSON: send the browser through it, then it can retry. */
          if (/\/challenge/.test(r.url || '')) { window.location.assign(root + 'cart'); throw new Error('Shopify asked for a quick verification. Complete it, then press Review & submit order again.'); }
          return r.text().then(function (t) {
            var j = null; try { j = t ? JSON.parse(t) : {}; } catch (e) { j = null; }
            if (!r.ok) throw new Error((j && (j.description || j.message)) || ('Shopify answered ' + r.status + ' on ' + path));
            if (!j) throw new Error('Unexpected reply from Shopify on ' + path);
            return j;
          });
        });
    };
    note('');
    post('cart/clear.js')
      .then(function () { return post('cart/add.js', { items: items }); })
      .then(function () { return post('cart/update.js', { attributes: { 'Wholesale packing': 'Garment only. No retail inserts (rosary, prayer card, rosary guide, zipper bag).' } }).catch(function () { return null; }); })
      .then(function () { return fetch(root + 'cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }); })
      .then(function (cart) {
        if (!cart || !cart.item_count) throw new Error('The items did not reach the cart. Nothing was ordered — please try again, or email ' + (cfg.repEmail || 'wholesale@saintsreserve.com') + '.');
        btn.textContent = 'Opening checkout…';
        window.location.assign(root + 'checkout');
        /* If the page is still here after a few seconds, the browser refused the navigation; say so instead of hanging. */
        setTimeout(function () { reset('Checkout did not open. Your ' + cart.item_count + ' item(s) are in the cart — open ' + (root + 'checkout') + ' directly.'); }, 8000);
      })
      .catch(function (e) { reset('Could not send to checkout: ' + e.message); });
  }
  /* Live mode: MSRP = the public retail price. Fetched anonymously (credentials omitted, so the
     B2B session is not applied) from /products/<handle>.js, read-only. Never derived from the tier. */
  var msrpCache = {};
  function hydrateMsrp(root) {
    if (cfg.mode !== 'live') return;
    root = root || document;
    var handles = {};
    $$('[data-w-matrix][data-product-handle]', root).forEach(function (m) { handles[m.dataset.productHandle] = 1; });
    $$('[data-w-msrp-handle]', root).forEach(function (el) { handles[el.dataset.wMsrpHandle] = 1; });
    $$('[data-w-msrp-product]', root).forEach(function (el) { handles[el.dataset.wMsrpProduct] = 1; });
    Object.keys(handles).forEach(function (h) {
      var p = msrpCache[h] ? Promise.resolve(msrpCache[h]) : fetch(cfg.rootUrl.replace(/\/$/, '') + '/products/' + encodeURIComponent(h) + '.js', { credentials: 'omit', headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (j) { if (!j) return null; var byId = {}; (j.variants || []).forEach(function (v) { byId[v.id] = v.price; }); msrpCache[h] = { min: j.price_min, max: j.price_max, byId: byId }; return msrpCache[h]; })
        .catch(function () { return null; });
      p.then(function (d) {
        if (!d) return;
        /* A catalog-supplied MSRP (fixed price list entry with a compare-at) is authoritative; the public retail price only fills gaps. */
        $$('[data-w-matrix][data-product-handle="' + h + '"] [data-w-qty]', root).forEach(function (inp) { if (inp.dataset.msrpFixed) return; var m = d.byId[inp.dataset.variantId]; if (m != null) inp.dataset.msrp = m; });
        $$('[data-w-msrp-handle="' + h + '"]', root).forEach(function (el) { var v = $('[data-w-msrp-val]', el); if (v) v.textContent = (el.dataset.wVaries ? 'from ' : '') + money(d.min); el.hidden = false; });
        $$('[data-w-profit-handle="' + h + '"]', root).forEach(function (el) { var p = d.min - Number(el.dataset.wWs || 0); if (p > 0) { el.textContent = money(p) + ' profit per unit'; el.hidden = false; } });
        $$('[data-w-matrix][data-product-handle="' + h + '"] .w-cell', root).forEach(function (cell) { var inp = $('[data-w-qty]', cell), pr = $('[data-w-cell-profit]', cell); if (!inp || !pr || pr.textContent) return; var m = Number(inp.dataset.msrp || 0), w = Number(inp.dataset.ws || 0); if (m > w) pr.textContent = money(m - w) + ' profit'; });
        $$('[data-w-msrp-product="' + h + '"]', root).forEach(function (el) {
          if (el.dataset.wMsrpFixed) return;
          el.textContent = d.min === d.max ? money(d.min) : money(d.min) + ' – ' + money(d.max);
          var prof = $('[data-w-profit-product]'); if (prof) prof.textContent = money(d.min - Number(el.dataset.wWsMin || 0));
        });
        sheet.lines.forEach(function (l) { var m = d.byId[l.id]; if (m != null && !l.msrp) l.msrp = m; });
        if (sheet.lines.length) { sheet.save(); sheet.render(); }
      });
    });
  }
  window.SRW = window.SRW || {}; window.SRW.hydrateMsrp = hydrateMsrp;
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  /* ---------- toast ---------- */
  var toastTimer;
  function toast(msg) {
    var el = $('[data-w-toast]');
    if (!el) return;
    el.textContent = msg;
    el.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.hidden = true; }, 2400);
  }

  /* ---------- order sheet store ---------- */
  var sheet = {
    lines: [],
    load: function () {
      try { this.lines = JSON.parse(localStorage.getItem(STORE_KEY) || '[]'); } catch (e) { this.lines = []; }
      if (!Array.isArray(this.lines)) this.lines = [];
    },
    save: function () {
      try { localStorage.setItem(STORE_KEY, JSON.stringify(this.lines)); } catch (e) { /* private mode: keep in memory */ }
    },
    add: function (line) {
      var qty = Math.max(0, Math.floor(Number(line.qty) || 0));
      if (!line.id || !qty) return 0;
      var max = Math.floor(Number(line.max) || 0);   /* per-order maximum from the catalog's quantity rule (0 = none) */
      var existing = this.lines.filter(function (l) { return String(l.id) === String(line.id); })[0];
      if (existing) {
        if (max) existing.max = max;
        var cap = existing.max ? Math.min(existing.qty + qty, existing.max) : existing.qty + qty;
        if (existing.max && existing.qty + qty > existing.max) toast('This item has a maximum of ' + existing.max + ' per order');
        qty = cap - existing.qty; existing.qty = cap;
      } else {
        if (max && qty > max) { toast('This item has a maximum of ' + max + ' per order'); qty = max; }
        this.lines.push({
          id: String(line.id), title: line.title || '', variantTitle: line.variantTitle || '', sku: line.sku || '',
          msrp: Number(line.msrp) || 0, ws: line.ws != null ? Number(line.ws) : wsPrice(line.msrp), qty: qty,
          image: line.image || '', handle: line.handle || '', max: max || 0
        });
      }
      this.save(); this.render();
      return qty;
    },
    setQty: function (id, qty) {
      qty = Math.max(0, Math.floor(Number(qty) || 0));
      this.lines = this.lines.map(function (l) {
        if (String(l.id) === String(id)) { if (l.max && qty > l.max) { toast('This item has a maximum of ' + l.max + ' per order'); qty = l.max; } l.qty = qty; }
        return l;
      }).filter(function (l) { return l.qty > 0; });
      this.save(); this.render();
    },
    remove: function (id) { this.setQty(id, 0); },
    clear: function () { this.lines = []; this.save(); this.render(); },
    totals: function () {
      var t = { units: 0, msrp: 0, total: 0, lines: this.lines.length };
      this.lines.forEach(function (l) { t.units += l.qty; t.msrp += l.msrp * l.qty; t.total += l.ws * l.qty; });
      return t;
    },
    render: function () {
      var t = this.totals();
      var min = Number(cfg.activeMinimum || 0);
      /* A product that counts as a complete order on its own (the 100-card bundle) waives the minimum for this order. */
      var waivers = cfg.minimumWaiverHandles || [];
      var waived = t.lines > 0 && this.lines.some(function (l) { return l.handle && waivers.indexOf(l.handle) !== -1; });
      var pct = waived ? 100 : (min ? Math.min(100, Math.round(t.total / min * 100)) : 100);
      var met = waived || t.total >= min;

      $$('[data-w-sheet-count]').forEach(function (el) { el.textContent = t.units; });
      $$('[data-w-sheet-units]').forEach(function (el) { el.textContent = t.units; });
      $$('[data-w-sheet-total]').forEach(function (el) { el.textContent = money(t.total); });
      $$('[data-w-sheet-total-mini]').forEach(function (el) { el.textContent = money(t.total); });
      $$('[data-w-sheet-msrp]').forEach(function (el) { el.textContent = money(t.msrp); });
      var noMsrp = t.lines > 0 && !t.msrp;
      var profit = t.msrp - t.total, marginPct = t.msrp ? Math.round(profit / t.msrp * 100) : Number(cfg.discount || 0);
      $$('[data-w-sheet-profit]').forEach(function (el) { el.textContent = noMsrp ? '—' : money(profit); });
      $$('[data-w-sheet-margin]').forEach(function (el) { el.textContent = noMsrp ? '—' : marginPct + '%'; });
      $$('[data-w-sheet-meter]').forEach(function (el) { el.style.width = pct + '%'; el.classList.toggle('is-met', met); var pb = el.parentElement; if (pb && pb.getAttribute('role') === 'progressbar') pb.setAttribute('aria-valuenow', pct); });
      $$('[data-w-sheet-min-note]').forEach(function (el) {
        el.classList.toggle('is-met', met);
        el.textContent = waived ? 'Minimum waived: the bundle counts as a complete order.' : (met ? 'Minimum met. Ready to submit.' : 'Add ' + money(min - t.total) + ' to reach the minimum.');
      });
      /* The line next to the button says in words why it is grey: empty sheet, or short of the minimum (and by how much). */
      $$('[data-w-sheet-gate]').forEach(function (el) {
        el.classList.remove('is-met', 'is-short');
        if (!t.lines) { el.textContent = 'Add items to start an order. The order minimum is ' + money(min) + '.'; }
        else if (!met) { el.classList.add('is-short'); el.textContent = money(t.total) + ' so far. Add ' + money(min - t.total) + ' more to reach the ' + money(min) + ' minimum, then you can submit.'; }
        else if (waived) { el.classList.add('is-met'); el.textContent = 'The bundle counts as a complete order, so the ' + money(min) + ' minimum is waived. Ready to submit.'; }
        else { el.classList.add('is-met'); el.textContent = 'Minimum met (' + money(t.total) + ' of ' + money(min) + '). Ready to submit.'; }
      });
      /* Retailer status as a story: where this order takes them. */
      $$('[data-w-sheet-tier]').forEach(function (el) {
        var next = cfg.nextTier, th = Number(cfg.nextThreshold || 0), spend = Number(cfg.rollingSpend || 0);
        if (!next || !th || !t.lines) { el.hidden = true; return; }
        var after = spend + t.total;
        el.hidden = false; el.classList.toggle('is-unlock', after >= th);
        el.textContent = after >= th
          ? 'This order takes you past ' + money(th) + ': ' + next + ' pricing (' + cfg.nextDiscount + '% off MSRP) on your next review.'
          : 'After this order: ' + money(after) + ' of ' + money(th) + ' toward ' + next + ' pricing (' + cfg.nextDiscount + '% off). ' + money(th - after) + ' to go.';
      });
      /* Free-shipping bar: only when the store has switched it on (a matching rate must exist in Shopify). */
      $$('[data-w-sheet-ship]').forEach(function (el) {
        var fs = Number(cfg.freeShippingThreshold || 0);
        if (!fs || !t.lines) { el.hidden = true; return; }
        el.hidden = false; el.classList.toggle('is-unlock', t.total >= fs);
        el.textContent = t.total >= fs ? 'Free shipping unlocked on this order.' : 'Add ' + money(fs - t.total) + ' for free shipping.';
      });
      $$('[data-w-sheet-submit]').forEach(function (el) {
        if (cfg.mode === 'live') {
          var ok = t.lines > 0 && met;
          el.disabled = !ok;
          el.title = !t.lines ? 'Add items first' : (met ? 'Send this order sheet to Shopify checkout' : 'Reach the order minimum to continue');
        } else {
          el.disabled = true; el.title = t.lines ? 'Checkout connects to Shopify B2B in a later phase' : 'Add items first';
        }
      });

      var tpl = $('[data-w-line-template]');
      $$('[data-w-sheet-lines]').forEach(function (container) {
        var empty = $('[data-w-sheet-empty]', container);
        $$('[data-w-line]', container).forEach(function (n) { n.remove(); });
        if (empty) empty.hidden = t.lines > 0;
        if (!tpl) return;
        sheet.lines.forEach(function (l) {
          var node = tpl.content.firstElementChild.cloneNode(true);
          node.dataset.id = l.id;
          var img = $('.w-line__img', node); img.src = l.image || ''; if (!l.image) img.style.visibility = 'hidden';
          $('[data-w-line-title]', node).textContent = l.title;
          $('[data-w-line-variant]', node).textContent = l.variantTitle && l.variantTitle !== 'Default Title' ? l.variantTitle : '';
          $('[data-w-line-sku]', node).textContent = l.sku ? l.sku : '';
          $('[data-w-line-unit]', node).textContent = money(l.ws);
          $('[data-w-line-msrp]', node).textContent = money(l.msrp);
          $('[data-w-line-qty]', node).value = l.qty;
          $('[data-w-line-total]', node).textContent = money(l.ws * l.qty);
          container.appendChild(node);
        });
      });
    }
  };

  /* ---------- drawer ---------- */
  var drawer = $('[data-w-sheet]');
  var lastFocus = null;
  function openSheet() { if (!drawer) return; lastFocus = document.activeElement; drawer.hidden = false; document.body.style.overflow = 'hidden'; var c = $('[data-w-sheet-close]', drawer); if (c) c.focus(); }
  function closeSheet() { if (!drawer) return; drawer.hidden = true; document.body.style.overflow = ''; if (lastFocus && lastFocus.focus) lastFocus.focus(); }
  function bump() { $$('[data-w-sheet-open].w-sheetbtn').forEach(function (b) { b.classList.remove('is-bump'); void b.offsetWidth; b.classList.add('is-bump'); }); }

  document.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target : null;
    if (!t) return;
    if (t.closest('[data-w-sheet-open]')) { e.preventDefault(); openSheet(); return; }
    if (t.closest('[data-w-start-order]')) { e.preventDefault(); if (sheet.lines.length) openSheet(); else location.href = (cfg.routes && cfg.routes.bestsellers) || cfg.rootUrl; return; }
    var dens = t.closest('[data-w-density]');
    if (dens) { setDensity(dens.getAttribute('data-w-density')); return; }
    if (t.closest('[data-w-sheet-close]')) { e.preventDefault(); closeSheet(); return; }
    if (t.closest('[data-w-sheet-clear]')) { if (sheet.lines.length && confirm('Clear the order sheet?')) { sheet.clear(); toast('Order sheet cleared'); } return; }
    var lineEl = t.closest('[data-w-line]');
    if (lineEl) {
      var id = lineEl.dataset.id, cur = sheet.lines.filter(function (l) { return l.id === id; })[0];
      if (t.closest('[data-w-line-inc]')) { sheet.setQty(id, (cur ? cur.qty : 0) + 1); return; }
      if (t.closest('[data-w-line-dec]')) { sheet.setQty(id, (cur ? cur.qty : 0) - 1); return; }
      if (t.closest('[data-w-line-remove]')) { sheet.remove(id); return; }
    }
    if (t.closest('[data-w-matrix-add]')) { addFromMatrix(t.closest('[data-w-matrix]')); return; }
    var reorderBtn = t.closest('[data-w-reorder]');
    if (reorderBtn) { reorderTable(document.querySelector(reorderBtn.getAttribute('data-w-reorder'))); return; }
    if (t.closest('[data-w-sheet-submit]')) { submitSheet(t.closest('[data-w-sheet-submit]')); return; }
    if (t.closest('[data-w-reorder-line]')) { var row = t.closest('[data-w-line-variant]'); if (row) { addRow(row); toast('Added ' + row.dataset.wLineTitle); bump(); } return; }
    var thumb = t.closest('[data-w-thumb]');
    if (thumb) { var main = $('[data-w-gallery-main]'); if (main) main.src = thumb.dataset.src; $$('[data-w-thumb]').forEach(function (b) { b.classList.toggle('is-active', b === thumb); }); return; }
    var chip = t.closest('[data-w-chip]');
    if (chip) { chip.classList.toggle('is-active'); applyFilter(); return; }
  });
  /* Named-variant list: focusing or clicking a row shows that variant's picture in the gallery. */
  function showVariantImage(cell) {
    var main = $('[data-w-gallery-main]'); if (!main || !cell || !cell.dataset.wVariantImage) return;
    if (main.src !== cell.dataset.wVariantImage) { main.src = cell.dataset.wVariantImage; main.alt = cell.dataset.wVariantName || main.alt; }
    $$('[data-w-thumb]').forEach(function (b) { b.classList.remove('is-active'); });
    $$('.w-cell.is-active').forEach(function (c) { if (c !== cell) c.classList.remove('is-active'); });
    cell.classList.add('is-active');
  }
  document.addEventListener('focusin', function (e) { var cell = e.target.closest && e.target.closest('.w-cell[data-w-variant-image]'); if (cell) showVariantImage(cell); });
  document.addEventListener('click', function (e) { var cell = e.target.closest && e.target.closest('.w-cell[data-w-variant-image]'); if (cell) showVariantImage(cell); });
  /* Opening-order kits: one click puts a proven mix on the sheet (through sheet.add, so maximums still apply). */
  document.addEventListener('click', function (e) {
    var kit = e.target.closest && e.target.closest('[data-w-kit]'); if (!kit) return;
    var lines = []; try { lines = JSON.parse(kit.dataset.wKitLines || '[]'); } catch (err) { lines = []; }
    var units = 0; lines.forEach(function (l) { units += sheet.add(l); });
    if (units) { toast((kit.dataset.wKitTitle || 'Kit') + ' added: ' + units + ' units'); bump(); openSheet(); }
    else toast('Nothing could be added from that kit');
  });
  /* Shop by saint: the select navigates. */
  document.addEventListener('change', function (e) { var j = e.target.closest && e.target.closest('[data-w-jump]'); if (j && j.value) window.location.assign(j.value); });
  /* "Same quantity for every saint" / size runs: fills the matching rows, then lets the normal input handlers recount. */
  document.addEventListener('click', function (e) {
    var apply = e.target.closest && e.target.closest('[data-w-fill-apply]');
    var clear = e.target.closest && e.target.closest('[data-w-fill-clear]');
    if (!apply && !clear) return;
    var matrix = (apply || clear).closest('[data-w-matrix]'); if (!matrix) return;
    var n = apply ? Math.max(0, parseInt(($('[data-w-fill-all]', matrix) || {}).value, 10) || 0) : 0;
    var run = apply && apply.dataset.wFillRun ? apply.dataset.wFillRun.split(',') : null;
    $$('[data-w-qty]', matrix).forEach(function (inp) {
      if (inp.disabled) return;
      if (run) { var size = (inp.dataset.variantTitle || '').split(' / ')[0].trim().toLowerCase().split(' ')[0].replace('xxlarge', '2xl').replace('xlarge', 'xl').replace('x-large', 'xl').replace('small', 's').replace('medium', 'm').replace('large', 'l'); if (run.map(function (s) { return s.toLowerCase(); }).indexOf(size) === -1) return; }
      var cap = inp.max ? Math.min(n, Number(inp.max)) : n; inp.value = cap ? String(cap) : ''; inp.dispatchEvent(new Event('input', { bubbles: true }));
    });
    var last = $$('[data-w-qty]', matrix).pop(); if (last) last.dispatchEvent(new Event('change', { bubbles: true }));
    matrixSummary(matrix);
    if (clear) { var f = $('[data-w-fill-all]', matrix); if (f) f.value = ''; }
  });
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t.matches('[data-w-line-qty]')) { var el = t.closest('[data-w-line]'); if (el) sheet.setQty(el.dataset.id, t.value); }
    if (t.matches('[data-w-sort-form] select')) { t.form.submit(); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && drawer && !drawer.hidden) closeSheet(); });

  /* ---------- size matrix ---------- */
  function matrixSummary(matrix) {
    var units = 0, total = 0;
    $$('[data-w-qty]', matrix).forEach(function (inp) { var q = Math.max(0, Math.floor(Number(inp.value) || 0)); units += q; total += q * Number(inp.dataset.ws || 0); });
    var s = $('[data-w-matrix-summary]', matrix);
    if (s) { $('[data-w-matrix-units]', s).textContent = units; $('[data-w-matrix-total]', s).textContent = money(total); s.classList.toggle('has-qty', units > 0); }
    return units;
  }
  document.addEventListener('input', function (e) {
    if (e.target.matches('[data-w-qty]')) { var m = e.target.closest('[data-w-matrix]'); if (m) matrixSummary(m); }
    if (e.target.matches('[data-w-filter]')) applyFilter();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && e.target.matches('[data-w-qty]')) { e.preventDefault(); var m = e.target.closest('[data-w-matrix]'); if (m) addFromMatrix(m); }
  });
  function addFromMatrix(matrix) {
    if (!matrix) return;
    var added = 0, count = 0;
    $$('[data-w-qty]', matrix).forEach(function (inp) {
      var q = Math.max(0, Math.floor(Number(inp.value) || 0));
      if (!q) return;
      count++;
      added += sheet.add({
        id: inp.dataset.variantId, title: matrix.dataset.productTitle, variantTitle: inp.dataset.variantTitle, sku: inp.dataset.sku,
        msrp: inp.dataset.msrp, ws: inp.dataset.ws, qty: q, image: matrix.dataset.productImage, handle: matrix.dataset.productHandle,
        max: inp.max
      });
      inp.value = '';
    });
    matrixSummary(matrix);
    if (added) { toast('Added ' + added + ' unit' + (added === 1 ? '' : 's') + ' of ' + matrix.dataset.productTitle); bump(); }
    else toast('Enter a quantity first');
  }
  function addRow(row) {
    return sheet.add({ id: row.dataset.wLineVariant, qty: row.dataset.wLineQty, title: row.dataset.wLineTitle, variantTitle: row.dataset.wLineVariantTitle, sku: row.dataset.wLineSku, msrp: row.dataset.wLineMsrp, ws: row.dataset.wLineWs, image: row.dataset.wLineImage });
  }
  function reorderTable(table) {
    if (!table) return;
    var units = 0;
    $$('[data-w-line-variant]', table).forEach(function (row) { units += addRow(row); });
    toast('Reordered ' + units + ' units'); bump(); openSheet();
  }

  /* ---------- shop-all page filter + type chips ---------- */
  function applyFilter() {
    var q = ($('[data-w-filter]') || {}).value || '';
    q = q.trim().toLowerCase();
    var active = $$('[data-w-chip].is-active').map(function (c) { return c.dataset.wChip; });
    var shown = 0;
    $$('[data-w-card]').forEach(function (card) {
      var hay = (card.dataset.title + ' ' + card.dataset.type + ' ' + card.dataset.tags).toLowerCase();
      var ok = (!q || hay.indexOf(q) > -1) && (!active.length || active.indexOf(card.dataset.type || '') > -1);
      card.hidden = !ok; if (ok) shown++;
    });
    var empty = $('[data-w-filter-empty]'); if (empty) empty.hidden = shown > 0;
  }
  (function buildChips() {
    var host = $('[data-w-type-chips]'); if (!host) return;
    var types = {};
    $$('[data-w-card]').forEach(function (c) { var t = c.dataset.type || ''; if (t) types[t] = (types[t] || 0) + 1; });
    var keys = Object.keys(types).sort();
    if (keys.length < 2) return;
    host.innerHTML = keys.map(function (k) { return '<button type="button" class="w-chip" data-w-chip="' + esc(k) + '">' + esc(k) + ' <span class="w-muted">' + types[k] + '</span></button>'; }).join('');
  })();

  /* ---------- bestsellers via Section Rendering API ----------
     Liquid can't sort by best-selling on the home page, so we ask Shopify to render a tiny
     section file against /collections/all?sort_by=best-selling and swap the grid in.
     Read-only GET; no admin objects involved. */
  $$('[data-w-bestsellers]').forEach(function (host) {
    var sectionId = host.getAttribute('data-w-bestsellers');
    if (!sectionId) return;
    var url = cfg.rootUrl.replace(/\/$/, '') + '/collections/all?section_id=' + encodeURIComponent(sectionId) + '&sort_by=best-selling';
    host.classList.add('is-loading');
    fetch(url, { credentials: 'same-origin' }).then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var grid = doc.querySelector('[data-w-best-grid]');
      var target = host.querySelector('[data-w-best-grid]');
      if (grid && target && grid.children.length) {
        // keep the same number of cards the server-rendered strip had (e.g. 4 on the dashboard)
        var keep = target.children.length || grid.children.length;
        while (grid.children.length > keep) grid.lastElementChild.remove();
        target.replaceWith(grid);
        hydrateMsrp(grid);
        $$('[data-w-matrix]', host).forEach(matrixSummary);
        // Landing hero wall: the six tiles become the top six bestsellers that have images.
        var wall = $('[data-w-hero-wall]');
        if (wall) {
          var imgs = $$('.w-card__media img', grid).slice(0, 6);
          if (imgs.length >= 3) {
            wall.innerHTML = imgs.map(function (im) {
              return '<div class="w-hero__tile"><img src="' + esc(im.getAttribute('src')) + '" srcset="' + esc(im.getAttribute('srcset') || '') + '" sizes="(min-width: 900px) 18vw, 30vw" alt="" width="' + esc(im.getAttribute('width') || '') + '" height="' + esc(im.getAttribute('height') || '') + '"></div>';
            }).join('');
          }
        }
      }
    }).catch(function () { /* keep the server-rendered fallback */ }).then(function () { host.classList.remove('is-loading'); });
  });

  /* ---------- nav active state for collection views ---------- */
  (function () {
    var sort = new URLSearchParams(location.search).get('sort_by');
    var key = sort === 'created-descending' ? 'new' : sort === 'best-selling' ? 'best' : (location.pathname.indexOf('/collections') === 0 || location.pathname.indexOf('/search') === 0 || location.pathname.indexOf('/products') === 0) ? 'shop' : null;
    if (!key) return;
    $$('.w-nav__link').forEach(function (a) { a.classList.remove('is-active'); });
    var el = $('[data-w-nav="' + key + '"]'); if (el) el.classList.add('is-active');
  })();

  /* ---------- catalog density (comfortable 4-up / compact 6-up) ---------- */
  function setDensity(mode) {
    mode = mode === 'compact' ? 'compact' : 'comfortable';
    $$('[data-w-grid]').forEach(function (g) { g.classList.toggle('w-grid--compact', mode === 'compact'); });
    $$('[data-w-density]').forEach(function (b) { var on = b.getAttribute('data-w-density') === mode; b.classList.toggle('is-active', on); b.setAttribute('aria-pressed', on ? 'true' : 'false'); });
    try { localStorage.setItem('srw_density', mode); } catch (e) {}
  }
  (function () { var saved = null; try { saved = localStorage.getItem('srw_density'); } catch (e) {} if ($('[data-w-grid]')) setDensity(saved || 'comfortable'); })();
  hydrateMsrp(document);

  /* ---------- contact forms (application, support) ----------
     NATIVE SUBMIT ONLY. The store runs Shopify's invisible captcha on contact forms: the token
     is attached by Shopify's script during a normal browser submit, so a fetch() post is
     refused with 400 "Missing CAPTCHA token" while Shopify's own handler still submits the
     form (2026-09-08: an error shown AND an email sent). So this never intercepts the post.
     It only disables the button to stop double clicks, and reveals the success panel when
     the page comes back with contact_posted=true / applied=1 / sent=1 (the return_to field). */
  function showFormSuccess(form) {
    var panel = form.parentElement && form.parentElement.querySelector('[data-w-form-success]');
    if (!panel) return false;
    panel.hidden = false; form.hidden = true;
    try { panel.scrollIntoView({ block: 'start', behavior: 'smooth' }); panel.focus({ preventScroll: true }); } catch (e) {}
    return true;
  }
  $$('[data-w-ajax-form]').forEach(function (marker) {
    var form = marker.closest('form'); if (!form) return;
    if (/[?&](contact_posted=true|applied=1|sent=1)/.test(location.search) && !form.hidden) showFormSuccess(form);
    form.addEventListener('submit', function () {
      var btn = form.querySelector('button[type="submit"]');
      if (!btn || btn.dataset.wSent === '1') return;
      btn.dataset.wSent = '1';
      /* Disable after the current submit has started; a disabled button submits nothing. */
      setTimeout(function () { btn.disabled = true; btn.textContent = 'Sending…'; }, 0);
      setTimeout(function () { btn.disabled = false; btn.dataset.wSent = ''; btn.textContent = btn.dataset.wLabel || 'Submit'; }, 15000);
      btn.dataset.wLabel = btn.textContent;
    });
  });

  /* ---------- boot ---------- */
  sheet.load();
  sheet.render();
  $$('[data-w-matrix]').forEach(matrixSummary);
  if (location.hash === '#order-sheet') openSheet();
  window.SRW.sheet = sheet;
  window.SRW.money = money;
})();
